import * as React from "react";
import { homeLink, request } from "../../../services/cpln";
import { NGProviderBrowser } from "./../ngProviderBrowser";
import { Mk8sInput } from "../../../schema/types/mk8s/input/mk8s";
import { Button, Divider, Space, Tooltip } from "antd";
import { inputToMk8s } from "../draft/utils/inputToMk8s";
import { formSet, formSetValue, useCpFormValue } from "../../gvc/testNewForm/utils";
import { store } from "../../../store";
import { CpInput } from "../../gvc/testNewForm/CpInput";
import { CpFormItem } from "../../gvc/testNewForm/CpFormItem";
import { CpLabel } from "../../gvc/testNewForm/CpLabel";
import { CpErrorWarning } from "../../gvc/testNewForm/CpErrorWarning";
import { CpDescription } from "../../gvc/testNewForm/CpDescription";
import { useCpFormContext } from "../../../components/form/useCpFormContext";
import { EllipsisOutlined } from "@ant-design/icons";

interface Props {
  provider: string;
  noMargin?: boolean;
}
export const ProviderNetworking: React.FC<Props> = ({ provider, noMargin }) => {
  const { id } = useCpFormContext();
  const serviceNetwork = useCpFormValue(`${provider}.networking.serviceNetwork`);
  const podNetwork = useCpFormValue(`${provider}.networking.podNetwork`);

  const [browserKey, setBrowserKey] = React.useState("");

  return (
    <div className={`${noMargin ? "" : "mb-8"}`}>
      <Divider orientation={"left"} orientationMargin={0}>
        Networking
      </Divider>
      <CpFormItem>
        <CpLabel name={`${provider}.networking.serviceNetwork`}>Service Network</CpLabel>
        <Space.Compact>
          <CpInput style={{ width: 600 }} name={`${provider}.networking.serviceNetwork`} />
          <Tooltip title={`Browse`}>
            <Button icon={<EllipsisOutlined />} onClick={() => setBrowserKey("serviceNetwork")} />
          </Tooltip>
        </Space.Compact>
        <CpErrorWarning name={`${provider}.networking.serviceNetwork`} />
      </CpFormItem>
      <CpFormItem>
        <CpLabel name={`${provider}.networking.podNetwork`}>Pod Network</CpLabel>
        <Space.Compact>
          <CpInput style={{ width: 600 }} name={`${provider}.networking.podNetwork`} />
          <Tooltip title={`Browse`}>
            <Button icon={<EllipsisOutlined />} onClick={() => setBrowserKey("podNetwork")} />
          </Tooltip>
        </Space.Compact>
        <CpErrorWarning name={`${provider}.networking.podNetwork`} />
      </CpFormItem>
      {["aws", "azure", "digitalocean", "generic", "hetzner", "linode", "triton"].includes(provider) ? (
        <>
          <CpFormItem>
            <CpLabel name={`${provider}.networking.dnsForwarder`}>DNS Forwarder</CpLabel>
            <CpDescription>
              DNS forwarder used by the cluster. Can be a space-delimited list of dns servers. Default is
              /etc/resolv.conf when not specified.
            </CpDescription>
            <CpInput style={{ width: 600 }} name={`${provider}.networking.dnsForwarder`} />
            <CpErrorWarning name={`${provider}.networking.dnsForwarder`} />
          </CpFormItem>
        </>
      ) : null}
      {browserKey === "serviceNetwork" ? (
        <NGProviderBrowser
          title="Browse Service Networks"
          initialValue={serviceNetwork}
          fetchData={async () => {
            const form = store.getState().form.instances[id];
            const values: Mk8sInput = form.values as any;

            const { data } = await request({
              service: "api",
              url: homeLink("mk8s") + "/-discover",
              method: "post",
              body: {
                objectType: "serviceNetworks",
                cluster: inputToMk8s(values),
              },
            });
            return data.data;
          }}
          onOk={(value) => {
            formSetValue(id, `${provider}.networking.serviceNetwork` as any, value as string);
            const form = store.getState().form.instances[id];
            formSet(id, `meta.onChangeCounter`, form.meta.onChangeCounter + 1);
          }}
          onClose={() => setBrowserKey("")}
          labels={["Service Network"]}
          getData={(item: any) => [item, item]}
        />
      ) : null}
      {browserKey === "podNetwork" ? (
        <NGProviderBrowser
          title="Browse Pod Networks"
          initialValue={podNetwork}
          fetchData={async () => {
            const form = store.getState().form.instances[id];
            const values: Mk8sInput = form.values as any;

            const { data } = await request({
              service: "api",
              url: homeLink("mk8s") + "/-discover",
              method: "post",
              body: {
                objectType: "podNetworks",
                cluster: inputToMk8s(values),
              },
            });
            return data.data.filter((d: any) => d !== "vpc");
          }}
          onOk={(value) => {
            formSetValue(id, `${provider}.networking.podNetwork` as any, value as string);
            const form = store.getState().form.instances[id];
            formSet(id, `meta.onChangeCounter`, form.meta.onChangeCounter + 1);
          }}
          onClose={() => setBrowserKey("")}
          labels={["Pod Network"]}
          getData={(item: any) => [item, item]}
        />
      ) : null}
    </div>
  );
};
